// 新聞、加密學院 文章頁 側邊標題目錄
'use client';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { popState, setCatalog } from '@/slices/popSlice';
import { useDispatch } from 'react-redux';

const AsideCatalog = ({ paragraph, t, id }) => {
    const { newsBar, showCatalog } = useSelector(popState);
    const dispatch = useDispatch();
    const [fold, setFold] = useState(true); // 目錄展開

    return (
        <>
            <aside
                className={`float-left sticky top-[100px] trans w-[250px] uxl:ml-[-10px] max-w-[200px] ulb:hidden
              ulg:fixed ulg:float-none ulg:left-0 ulg:w-screen ulg:max-w-none ulg:bg-[rgba(255,255,255,.8)] dark:ulg:bg-[rgba(14,14,14,.56)] ulg:max-h-[300px] ulg:noScrollY
              ulg:backdrop-blur-[10px] ulg:!ml-0 ulg:py-[20px] ulg:px-[30px] ulg:top-[unset] ulg:border-t-1 ulg:border-[#e4e4e4] ulg:z-[-1] ulg:opacity-0
              ${id === newsBar?.newsId ? 'bottom-0 ulg:!block' : 'ulg:!hidden'} ${
                    showCatalog ? '!bottom-[55px] ulg:!z-[5] !opacity-[1]' : ''
                }`}
            >
                <button
                    onClick={() => setFold((prev) => !prev)}
                    className="text-btn3b text-black9 py-[10px] pr-[10px] mb-[12px] ulg:hidden"
                >
                    <span className="inline-block w-[20px]">{fold ? '-' : '+'}</span>
                    {t('FOLD')}
                </button>

                <p className="hidden text-black9 text-btn3b ulg:block mb-[12px]">{t('MENU')}</p>

                {/* 標題連結 */}
                <ul
                    className={`max-h-[65vh] trans noScrollY pb-[15px] ${
                        !fold ? 'opacity-0 translate-x-[-10px]' : 'opacity-1 translate-x-[0]'
                    } text-bd4n ulg:max-h-[calc(100vh-108px)]`}
                >
                    {paragraph?.map((title, i) => {
                        return (
                            <li
                                key={title?.id + 'paragraph'}
                                className={`py-[10px] ulg:py-[13px] ${
                                    i < paragraph?.length - 1 && title?.tag === 'H2'
                                        ? 'border-b-1 border-dashed border-black2 '
                                        : ''
                                }`}
                                onClick={() => dispatch(setCatalog(false))}
                            >
                                <a
                                    href={`#${title?.id}`}
                                    className={`w-full line-clamp-1 ${
                                        title?.tag === 'H3'
                                            ? 'max-w-[calc(100%-30px)] ml-[30px] text-black6'
                                            : 'text-black'
                                    } trans hover:text-pale9`}
                                >
                                    {title?.content}
                                </a>
                            </li>
                        );
                    })}
                </ul>

                <div className="absolute bottom-0 left-0 w-full h-[20px] z-[1] backdrop-blur-[5px] ulg:hidden" />
            </aside>
            <div
                className={`w-screen fixed z-[4] top-0 h-full left-0  ${
                    showCatalog ? 'ulg:block' : 'hidden'
                }`}
                onClick={() => dispatch(setCatalog(false))}
            />
        </>
    );
};

export default AsideCatalog;
